import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_COLLECTION_FUNCTION_GROUP,
  CollectionFunctionGroup,
} from './collectionFunctionGroup.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getCollectionFunctionGroupList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<CollectionFunctionGroup>> {
  return http.get(`${API_PATH_COLLECTION_FUNCTION_GROUP}/${deliveryFunctionId}`);
}

export function getCollectionFunctionGroup(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<CollectionFunctionGroup>> {
  return http.get(`${API_PATH_COLLECTION_FUNCTION_GROUP}/${deliveryFunctionId}/${id}`);
}

export function createCollectionFunctionGroup(
  deliveryFunctionId: string,
  body: WithAuditDetails<CollectionFunctionGroup>,
): AxiosPromise<ServerResponse<CollectionFunctionGroup>> {
  return http.post(`${API_PATH_COLLECTION_FUNCTION_GROUP}/${deliveryFunctionId}`, body);
}

export function updateCollectionFunctionGroup(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<CollectionFunctionGroup>,
): AxiosPromise<ServerResponse<CollectionFunctionGroup>> {
  return http.put(`${API_PATH_COLLECTION_FUNCTION_GROUP}/${deliveryFunctionId}/${id}`, body);
}

export function deleteCollectionFunctionGroup(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<CollectionFunctionGroup>> {
  return http.delete(`${API_PATH_COLLECTION_FUNCTION_GROUP}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
